import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import React from "react";
import { useIntl } from "react-intl";

import MallOrdersList from "../MallOrdersList/MallOrdersList";
import { createFilterStructure } from "./filters";

function MallOrdersListPage({
  currencySymbol,
  currentTab,
  tabs,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  filterOpts,
  handleDownload,
  mallOrders,
  ...listProps
}) {
  const intl = useIntl();
  const strcuture = createFilterStructure(intl, filterOpts);

  return (
    <>
      <Container>
        <PageHeader title="Mall Orders">
          <Button
            color="primary"
            disabled={!mallOrders}
            variant="contained"
            onClick={handleDownload}
          >
            Download
          </Button>
        </PageHeader>
        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={strcuture}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: " "
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <MallOrdersList mallOrders={mallOrders} {...listProps} />
        </Card>
      </Container>
    </>
  );
}

export default MallOrdersListPage;
